"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.timeEntryAbsenceTypes = exports.absenceTypes = exports.TimeEntryType = void 0;
exports.timeEntryTypeColor = timeEntryTypeColor;
const colors_1 = require("../colors");
var TimeEntryType;
(function (TimeEntryType) {
    TimeEntryType["Work"] = "working";
    TimeEntryType["Sick"] = "sick";
    TimeEntryType["Vacation"] = "vacation";
    TimeEntryType["ChildSick"] = "child_sick";
    TimeEntryType["SickInKUG"] = "sick_in_kug";
    TimeEntryType["School"] = "school";
    TimeEntryType["HourAdjustment"] = "hour_adjustment";
    TimeEntryType["VacationAdjustment"] = "vacation_adjustment";
    TimeEntryType["Free"] = "free";
    TimeEntryType["CompDay"] = "compday";
    TimeEntryType["ResetLedgers"] = "reset_ledgers";
})(TimeEntryType || (exports.TimeEntryType = TimeEntryType = {}));
exports.absenceTypes = [
    TimeEntryType.Vacation,
    TimeEntryType.Sick,
    TimeEntryType.ChildSick,
    TimeEntryType.SickInKUG,
    TimeEntryType.CompDay,
];
exports.timeEntryAbsenceTypes = [
    TimeEntryType.Sick,
    TimeEntryType.Vacation,
    TimeEntryType.ChildSick,
    TimeEntryType.SickInKUG,
    TimeEntryType.CompDay,
];
function timeEntryTypeColor(type) {
    switch (type) {
        case TimeEntryType.Vacation:
            return colors_1.colors.blue;
        case TimeEntryType.Sick:
        case TimeEntryType.ChildSick:
        case TimeEntryType.SickInKUG:
            return colors_1.colors.orange;
        case TimeEntryType.School:
            return colors_1.colors.violet;
        case TimeEntryType.Free:
            return colors_1.colors.grey;
        case TimeEntryType.CompDay:
            return colors_1.colors.aqua;
        default:
            return "";
    }
}
//# sourceMappingURL=time-entry-type.js.map